export default {
      id: "powered-by-lantern-usage",
      viewBox: "0 0 148.361 37.644",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#powered-by-lantern",
      toString: function () {
        return this.url;
      }
    }